module.exports = __webpack_public_path__ + "static/locales/id.3ZhomJS.json";